<template>

<transition name="slide-fade">

	<span>

		<main class="col-xs-12 internaslider" v-if="loaded_sticky=='true'">
			<ul>
				<li v-for="programa in programas_sticky">
					<img v-if="programa.imagen_horizontal.sizes.hasOwnProperty('1440x446')" v-bind:src="programa.imagen_horizontal.sizes['1440x446']" alt="">
					<img v-else-if="programa.imgs.hasOwnProperty('1440x446')" v-bind:src="programa.imgs['1440x446']" alt="">
					<img v-else v-bind:src="theme_url+'/html/assets/img/programacion-1.jpg'" alt="">
				</li>
			</ul>
		</main>
		<div class="col-xs-12 block programacion" v-if="loaded=='true'">
			<div class="container">
				<div class="row">
					<h2>PROGRAMACION</h2>
					<ul class="col-xs-12 filtro">
						<li class="active"><a mostrar="todo" href="#">Todo</a></li>
						<li><a href="#" mostrar="entresemana">LUNES A VIERNES</a></li>
						<li><a href="#" mostrar="finde">FIN DE SEMANA</a></li>
					</ul>

					<!-- ITEM -->
					<div v-for="programa in programas" v-bind:class="'col-xs-12 col-xs-6 col-md-3 progitem progitem'+programa.semana_finde">
						<div class="col-xs-12 npd progitem__wrap paused">
							<router-link :to="{ name: 'programa', params: { elprograma: programa.slug }}" class="toint">

								<figure>
									<img v-if="programa.better_featured_image != null " v-bind:src="programa.better_featured_image.media_details.sizes['367x256'].source_url" alt="">
									<img v-else v-bind:src="'http://via.placeholder.com/367x256/008AD2/dddddd?text='+programa.title.rendered" alt="">
									<div class="flex-centermid progitem__des">
										 <!-- <h4>Lunes a Viernes</h4> -->
										 <p><i class="icon time"></i><span v-html="programa.acf.horarios_texto"></span></p>
									</div>
								</figure>

								<h3 v-html="programa.title.rendered"></h3>

							</router-link>
							<button v-if="programa.post_meta != 0" v-bind:audio="programa.post_meta._enclosure_mp3" class="reflexiones__player flex-centermid btn">
							 	<i class="icon play-mini-white"></i>
							</button>
						</div>
					</div>
					<!--
					<div class="col-xs-12 nextprev">
						<a v-on:click="rtShowPrev()" id="rtShowPrev"><img v-bind:src="theme_url+'/html/assets/img/left.png'" alt=""></a>
						<a v-on:click="rtShowNext()" id="rtShowNext"><img v-bind:src="theme_url+'/html/assets/img/right.png'" alt=""></a>
					</div>	
				-->
				</div>
			</div>
		</div>
	</span>

</transition>

</template>



<script>
export default {
	mounted: function() {
		const vm = this;
		vm.getProgramas();
		vm.getProgramasSticky();
		vm.$store.commit( 'rtChangeTitle', 'Programas' );

	},
	data() {
		return {
			theme_url:rtwp.theme_url,
			programas: {},
			programas_sticky: {},
			loaded: 'false',
			loaded_sticky: 'false',
			currentPage: '',
			prevPage: '',
			nextPage: '',
			showNext: 'false',
			showPrev: 'false',
			postPerPage: '99',
			totalPages: '',
			orderby: 'menu_order',
			order : 'asc',
		};
	},
	methods: {
		getProgramas: function( pageNumber = 1 ) {
			const vm = this;
			vm.loaded = 'false';
			vm.$http.get( 'wp/v2/programas?per_page=99&orderby=menu_order&order=asc' )
			.then( ( res ) => {
				vm.programas = res.data;
				vm.loaded = 'true';
				vm.totalPages = res.headers[ 'x-wp-totalpages' ];
				vm.showNext='true';
				vm.showPrev='true';
				if ( pageNumber <= parseInt( vm.totalPages ) ) {
					vm.currentPage = parseInt( pageNumber );
				} else {
					vm.currentPage = 1;
				}
				vm.$nextTick(function(){
					jQuery(".player__playlist").musicPlayer();

					jQuery('div.programacion ul.filtro').on('click', 'li a', function(ev){
						ev.preventDefault();
						var self=this;
						var cual=jQuery(self).attr('mostrar');
						jQuery(self).parents('ul').find('li').removeClass('active');
						jQuery(self).parents('li').addClass('active');
						if(cual=='entresemana'){
							jQuery('div.progitem').hide();
							jQuery('div.entresemana').show();
						}
						if(cual=='finde'){
							jQuery('div.progitem').hide();
							jQuery('div.finde').show();
						}
						if(cual!='entresemana' && cual!='finde' ){
							jQuery('div.progitem').show();
						}
					});
					setTimeout(function(){
						jQuery('div.progitem__wrap').on('click','button.reflexiones__player', function(event) {
							event.preventDefault();
							var self=this;
							var audio=jQuery('#elementodeaudio');
							var estado=jQuery(self).parent().hasClass('paused');
							if(estado!=true){
								jQuery('div.progitem__wrap').addClass('paused');
								jQuery(audio).trigger('pause');
							} else {
								jQuery(audio).prop('src',jQuery(self).attr('audio'));
								jQuery(self).parent().removeClass('paused');
								jQuery(audio).trigger('play');

							}
						});
					},500);
					init_attach();	
				});
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );

		},
		getProgramasSticky: function(  ) {
			const vm = this;
			vm.loaded_sticky = 'false';
			vm.$http.get( 'programas/sticky')
			.then( ( res ) => {
				vm.programas_sticky = res.data;
				vm.loaded_sticky = 'true';
				vm.$nextTick(function(){
					init_attach();
				});
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );

		},
		rtShowNext: function( event ) {
			const vm = this;
			if ( vm.currentPage < vm.totalPages ) {
				vm.currentPage = vm.currentPage + 1;
				vm.getProgramas(vm.currentPage);
				//vm.$router.push( { 'name': 'category', params: { categories: vm.LaCat.id, page: vm.currentPage,per_page: vm.postPerPage } } );
			}
		},
		rtShowPrev: function( event ) {
			const vm = this;
			if ( vm.currentPage != 1 ) {
				vm.currentPage = vm.currentPage - 1;
				vm.getProgramas(vm.currentPage);
				//vm.$router.push( { 'name': 'category', params: { categories: vm.LaCat.id, page: vm.currentPage,per_page: vm.postPerPage } } );
			}
		},
	}

};
</script>



// WEBPACK FOOTER //
// programas.vue?09ba764d